import React from "react";
import { motion } from "framer-motion";

const programmes = [
  {
    title: <h2 className="text-xl text-gray-800 font-semibold" style={{ fontSize: '24px' }}>Forest & Wildlife Trail Safari</h2>,
    description:
      "Ride through dense, shaded forest paths where the scent of wild herbs fills the air and the sounds of birdsong accompany every hoofbeat. These nature-immersive trails take you close to wildlife reserves and buffer zones, offering quiet chances to spot deer, peacocks, monkeys, and a variety of native birds. Ideal for those seeking peace, connection with nature, and a sense of riding through untamed land.",
    image: "/images/2041ch.jpg",
  },
  {
    title: <h2 className="text-xl text-gray-800 font-semibold" style={{ fontSize: '24px' }}>Mountain & Hill Trail Safari</h2>,
    description:
      "Saddle up for adventure as you explore rugged hills and mountain trails on horseback. These rides blend steep inclines, open forest paths, and panoramic views, making them perfect for those who love a physical challenge and natural beauty. With a mix of forest cover and exposed ridgelines, these trails are a thrilling escape for adventure seekers and confident riders.",
    image: "/images/2031mh.jpg",
  },
  {
    title: <h2 className="text-xl text-gray-800 font-semibold" style={{ fontSize: '24px' }}>Village Experience Trail</h2>,
    description:
      "Step into the heart of rural India with trails that wind through age-old villages, farmland, and narrow mud paths. Along the way, you’ll witness everyday life—children walking to school, women drawing water from ancient wells, and artisans crafting by hand. Enjoy interactive moments with locals and gain an authentic glimpse into traditional Marwari hospitality and culture.",
    image: "/images/3horses.jpg",
  },
  {
    title: <h2 className="text-xl text-gray-800 font-semibold" style={{ fontSize: '24px' }}>River & Waterbody Trail</h2>,
    description:
      "Follow scenic routes that pass near rivers, seasonal streams, or tranquil lakes—ideal for a refreshing and visually stunning ride. These trails are particularly beautiful at sunrise and sunset, offering fantastic photo opportunities and chances to see waterbirds, herons, and other aquatic life. Cool breezes, gentle splashes, and quiet serenity make this a favorite among photographers and nature lovers.",
    image: "/images/2022rid.jpg",
  },
];

const CoreProgrammesSection = () => {
  return (
    <section id="experiance" className="py-16 px-4 md:px-20 bg-[#faf9f6]">
      <motion.h2
        className="text-3xl md:text-4xl font-semibold text-center mb-12"
        initial={{ opacity: 0, y: 50 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
        viewport={{ once: true, amount: 0.3 }}
      >
        Safari Ride's
      </motion.h2>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
        {programmes.map((item, idx) => (
          <motion.div
            key={idx}
            className="flex flex-col items-start"
            initial={{ opacity: 0, y: 60 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: idx * 0.2 }}
            viewport={{ once: true, amount: 0.3 }}
          >
            <img
              src={item.image}
              alt={item.title}
              className="rounded-lg w-full h-[280px] object-cover mb-4"
            />
            <h3 className="text-lg font-semibold tracking-wide">{item.title}</h3>

            {/* Only show subtitle if it exists */}
            {item.subtitle && (
              <p className="uppercase text-sm text-gray-600 mt-1 mb-3 tracking-wider">
                {item.subtitle}
              </p>
            )}

            <p className="text-sm text-gray-800 leading-relaxed">{item.description}</p>
          </motion.div>
        ))}
      </div>
    </section>
  );
};

export default CoreProgrammesSection;
